import * as yup from 'yup';

export const schemaCriarBeneficio = yup.object().shape({
  IdPromocao: yup.string().required('Id da promoção é obrigatória'),
  IdProduto: yup.string().required('Produto é obrigatório'),
  Quantidade: yup.number().required('Quantidade é obrigatória'),
  TipoDesconto: yup.string().required('Tipo do desconto é obrigatório'),
});

export const schemaEditarBeneficio = yup.object().shape({
  IdProduto: yup.string().required('Produto é obrigatório'),
  Quantidade: yup.number().required('Quantidade é obrigatória'),
  TipoDesconto: yup.string().required('Tipo do desconto é obrigatório'),
  ValorDesconto: yup.number().when('TipoDesconto', {
  is: (tipoDesconto) => tipoDesconto === 'VALOR_FIXO' || tipoDesconto === 'PERCENTUAL',
  then: () => yup.number()
    .required('O valor do desconto é obrigatório')
    .positive('O valor do desconto deve ser maior que zero')
    .typeError('O valor do desconto deve ser um número'),
  otherwise: () => yup.number().notRequired(),
}),
});